import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { InvoiceDto, InvoiceLineDto } from "@shared/models";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { JobService, ProductSettingService } from "../../common/services";

@Component({
  templateUrl: "./invoice-print.component.html",
  styleUrls: ["./invoice-print.component.scss"],
})
export class InvoicePrintComponent implements OnInit {
  private invoiceId: string;

  invoice: InvoiceDto;
  today = Date.today();
  noteName = "Tax Invoice";

  companyName: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  addressLine5: string;
  postalCode: string;
  countryCode: string;
  websiteURL: string;
  registrationNumber: string;
  vatNumber: string;

  constructor(private route: ActivatedRoute, private jobService: JobService,
              private productSettings: ProductSettingService) {
  }

  ngOnInit(): void {
    this.productSettings
      .getCompanyInfo()
      .toPromise()
      .then(info => {
        this.companyName = info.name;
        this.addressLine1 = info.lines[0];
        this.addressLine2 = info.lines[1];
        this.addressLine3 = info.lines[2];
        this.addressLine4 = info.lines[3];
        this.addressLine5 = info.lines[4];
        this.postalCode = info.postalCode;
        this.countryCode = info.country;
        this.websiteURL = info.website;
        this.registrationNumber = info.registrationNumber;
        this.vatNumber = info.vatNumber;
        // this.email = info.emailAddress;
        // this.telephone = info.telephone;
      });

    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.readParams(params.get("invoice"))))
        .subscribe(p => this.invoiceLaded(p));
  }

  private invoiceLaded(invoice: InvoiceDto) {
    this.invoice = invoice;
    if (this.subTotal() < 0)
      this.noteName = "Credit Note";
  }
  private readParams(invoice: string): Observable<InvoiceDto> {
    this.invoiceId = invoice;
    //    this.deliveryNoteId = deliveryNoteId;
    return this.jobService.getInvoice(invoice);
  }

  subTotal(): number {
    return this.invoice.subTotal ||  this.invoice.lines.reduce((tot: number, line: InvoiceLineDto) => tot + line.delivered * line.price, 0);
  }

  vat(): number {
    const rate = this.invoice.resource.vatRegistered ? 0.15 : 0;
    return this.invoice.vat || rate * this.subTotal() ;
  }

}
